/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useEffect, useState } from 'react';
import MonsterContainer from './MonsterContainer';
import './App.css';
import ApiService from './services/ApiService';
import PreferenceService from './services/PreferenceService';

const MonsterForge: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initDb = async () => {
      let refreshNeeded = true;
      const now = new Date();
      const dateStr = await PreferenceService.getUserPreference('Last Api Check Date');
      if (dateStr) {
        const date = new Date(dateStr);
        const oneDayLater = new Date(date.getTime() + 24 * 60 * 60 * 1000);
        refreshNeeded = (oneDayLater < now) || (date > now);
      }
      
      try {
        if (refreshNeeded) {
          await ApiService.clearStaleData();
          PreferenceService.setUserPreference('Last Api Check Date', now.toISOString());
        } else {
          console.log(`Not clearing out stale data, because current 'Last Api Check Date' is ${dateStr}`);
        }
        setLoading(false);
      } catch (error) {
        console.error('Failed to clear stale data:', error);
      }
    };
    initDb();
  }, []);

  if (loading) {
    // Show loading message until data is available
    return (<div style={{ textAlign: 'center', width: '400px', color: 'white', textShadow: '0px 0px 3px black' }}>
      <h1><b>Checking for<br/>Data Updates...</b></h1>
      </div>);
  }

  return <MonsterContainer />;
};

export default MonsterForge;
